const HALO_SCORES_FOR_KEY_RISK_AREAS_DESCRIPTION =
  "This chart shows Halo Intrinsic Scores for each of the your company's key enterprise risk areas. Scores are graded out of a 100. A high score indicates a strong standing while lower scores indicate greater risk.";

export default HALO_SCORES_FOR_KEY_RISK_AREAS_DESCRIPTION;
